import axios, { AxiosError, AxiosResponse } from 'axios';
// config
import { HOST_API } from 'src/config-global';
// components
import { enqueueSnackbar } from 'src/components/snackbar';
// eslint-disable-next-line import/no-cycle
import { setSession } from 'src/auth/context/utils';
import { paths } from 'src/routes/paths';

// ----------------------------------------------------------------------

const axiosInstance = axios.create({ baseURL: HOST_API });
axios.defaults.withCredentials = true;

const sleep = () => new Promise((resolve) => setTimeout(resolve, 0));

// axios.interceptors.request.use((config) => {
//   const STORAGE_KEY = 'accessToken';
//   const accessToken = localStorage.getItem(STORAGE_KEY);
//   if (accessToken) axios.defaults.headers.common.Authorization = `Bearer ${accessToken}`;
//   return config;
// });

axiosInstance.interceptors.response.use(
  async (response) => {
    await sleep();
    return response;
  },
  (error: AxiosError) => {
    // console.log(error);
    if (error?.response) {
      const { data, status } = error?.response as AxiosResponse;
      switch (status) {
        case 400:
          // if (data.errors) {
          //   const modelStateErrors: string[] = [];
          //   for (const key in data?.errors) {
          //     if (data.errors[key]) modelStateErrors.push(data.errors[key]);
          //   }
          //   throw modelStateErrors.flat();
          // }
          enqueueSnackbar(data?.detail ?? data?.detail?.error?.message, {
            variant: 'error',
          });
          break;
        case 401:
          enqueueSnackbar('نشست شما معتبر نمی باشد', {
            variant: 'error',
          });
          setSession(null);
          setTimeout(() => {
            // const searchParams = new URLSearchParams({ returnTo: window.location.href }).toString();

            const loginPath = paths.auth.login;

            // const href = `${loginPath}?${searchParams}`;

            window.location.href = loginPath;
          }, 1000);
          break;
        case 403:
          enqueueSnackbar('شما دسترسی لازم را ندارید', {
            variant: 'warning',
          });
          // window.location.href = '/403';
          break;
        case 404:
          enqueueSnackbar(data?.detail, {
            variant: 'error',
          });
          break;
        case 413:
          enqueueSnackbar('Payload Too Large', {
            variant: 'error',
          });
          break;
        case 500:
          enqueueSnackbar('خطایی سمت سرور رخ داده است', {
            variant: 'error',
          });
          // Router.navigate('/server-error', { state: { error: data } });
          break;
        default:
          enqueueSnackbar(data?.detail, {
            variant: 'error',
          });
          break;
      }
    }
    if (error?.code === 'ERR_NETWORK')
      enqueueSnackbar('خطا در برقراری ارتباط', {
        variant: 'error',
      });
    return Promise.reject((error?.response && error?.response?.data) || 'something went wrong');
  }
);

export default axiosInstance;

export const API_ENDPOINTS = {
  statistics: '/api/v1/public/statistics',
  auth: {
    me: '/api/v1/me',
    login: '/api/v1/login',
    logout: '/api/v1/logout',
    register: '/api/v1/register/finalize',
    request_otp: '/api/v1/request-otp',
    verify_otp: '/api/v1/verify-otp',
    forgot_password: '/api/v1/forgot-password/finalize',
    get_captcha: '/api/v1/captcha/get-data',
    check_captcha: '/api/v1/captcha/check-data',
    check_captcha_status: '/api/v1/captcha/check-status',
  },
  notifications: {
    list: '/api/v1/notifications',
    unseen_count: '/api/v1/notifications/unseen-count',
    seen: '/api/v1/notifications/seen',
    seen_all: '/api/v1/notifications/seen-all',
  },
  user: {
    list: '/api/v1',
    root: '/api/v1',
    usage: '/api/v1/usage/',
    change_password: '/api/v1/me/change-password',
    update: '/api/v1/users/{user_id}/update',
    invite_link: '/api/v1/invite-link',
  },
  upload_file: '/api/v1/upload/',
  upload_image: '/api/v1/upload-image-attachment/',
  chat: '/api/v1/chat',
  session: {
    root: '/api/v1/sessions/',
    pin: '/api/v1/sessions/{session_id}/pin',
    update: '/api/v1/sessions/{session_id}/update',
    image_generation: '/api/v1/generate-image/',
    ask: '/api/v1/ask/',
    stop: '/api/v1/stop/',
  },
  payment: {
    calculate: '/api/v1/payment/calculate_price',
    request: '/api/v1/payment/request',
    discount: '/api/v1/discounts/',
    transactions: '/api/v1/transactions',
  },
  models: '/api/v1/models',
};
